import React from 'react'
import { 
    Drawer as ChakraDrawer, DrawerBody, DrawerContent, 
    DrawerOverlay, DrawerCloseButton, DrawerHeader, 
    DrawerFooter 
} from '@chakra-ui/react'


const Drawer = (props) => {

    const modalRef= React.createRef()
    let {open, size, onClose, bg, transition, closeable=true, footer, title, placement, ...rest} = props
    return(
        <ChakraDrawer 
            isOpen={open || false} 
            size={size || "lg"}  
            onClose={onClose} 
            motionPreset={transition || "slideInRight"}
            autoFocus={false}
            initialFocusRef={modalRef}
            placement={placement || "right"}
            blockScrollOnMount={false}
            {...rest}            
            >
            <DrawerOverlay />
            <DrawerContent>
                {
                    title &&
                    <DrawerHeader px="7" fontSize="18px" fontWeight="700" color="gray.600" py="10px" borderBottom="1px solid" borderColor="gray.200" bg="white">{title}</DrawerHeader>
                }
                
                {
                    closeable && <DrawerCloseButton rounded="full" _focus={{ outline: "none" }} />
                }
                
                <DrawerBody p={props.p}   bg={bg || 'white'}>
                    {props.children}
                </DrawerBody>
                {
                    footer &&
                    <DrawerFooter borderTop="1px solid" borderColor="gray.200" bg="gray.50">
                        {footer}
                    </DrawerFooter>
                }
                
                <div ref={modalRef}/>
            </DrawerContent>    
        </ChakraDrawer>
    )
}

export {Drawer}